export const LMS_Routes: Record<string, string> = {
	dashboard: '/',
	createAssignment: '/create-assignment'
};

function createLMSRoutesHandler() {
	let lmsRoutes: Record<string, string> = { ...LMS_Routes };

	function getLMSRoutes(): typeof LMS_Routes {
		return lmsRoutes;
	}

	function mutateLMSRoutes(postfix: string): typeof LMS_Routes {
		lmsRoutes = {};
		const routeKeys = Object.keys(LMS_Routes);
		return routeKeys.reduce<Record<string, string>>((acm, key) => {
			const base = `${LMS_Routes.HOME}${postfix}`;
			acm[key] =
				LMS_Routes[key] === LMS_Routes.HOME
					? base
					: `${base}${LMS_Routes[key]}`;
			return acm;
		}, lmsRoutes);
	}

	return {
		mutateLMSRoutes,
		getLMSRoutes
	};
}

const routesHandler = createLMSRoutesHandler();

export const getLMSRoutes = routesHandler.getLMSRoutes;
export const mutateLMSRoutes = routesHandler.mutateLMSRoutes;
